'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (root, factory) {
    if (typeof module !== 'undefined' && module.exports !== undefined) {
        module.exports = factory();
    } else if (typeof define !== 'undefined' && define.amd) {
        define('ICVV', [], function () {
            return factory();
        });
    } else {
        root.ICVV = factory();
    }
})(window || module || {}, function () {
    var ICVV = function () {

        /**
         * CVV constructor
         * @param {string} value
         */
        function ICVV(value) {
            _classCallCheck(this, ICVV);

            if (value instanceof ICVV) {
                this.value = value.value;
            } else {
                this.value = String(value).replace(/\s+/g, '');
            }

            if (!this.validate()) {
                this.value = '';
            }

            return this;
        }

        /**
         * @return {boolean}
         */


        _createClass(ICVV, [{
            key: 'validate',
            value: function validate() {
                return (/^[0-9]{3,4}$/.test(this.value)
                );
            }

            /**
             * @return {string}
             */

        }, {
            key: 'toString',
            value: function toString() {
                return this.value || '';
            }

            /**
             * @param {string} value
             * @return {boolean}
             */

        }, {
            key: 'is',
            value: function is(value) {
                return this.value === new ICVV(value).value;
            }

            /**
             * @return {string}
             */

        }, {
            key: 'toHtml',
            value: function toHtml() {
                console.warn('ICVV prototype.toHtml() is deprecated. Use .toString().');
                return this.toString();
            }
        }]);

        return ICVV;
    }();

    return ICVV;
});